import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CalculationStore } from '../../../../../stores/calculation.store';
import { CalculationError } from '../../../../../../../../../../../common/src/errors/calculations/calculation.error';
import {
  calculationErrorMetadata,
} from '../../../../../../../../../../../common/src/metadatas/calculation-error.metadata';
import { TranslateService } from '@ngx-translate/core';
import {
  CalculationResponse,
} from '../../../../../../../../../../../common/dist/angular/responses/calculation.response';
import {
  Section84_1Options,
} from '../../../../../../../../../../../common/src/options/calculations/section-84_1/section-84_1.options';
import {
  Section84_1Result,
} from '../../../../../../../../../../../common/dist/angular/results/calculations/section-84_1/section-84_1.result';

@Component({
  selector: 'app-section-84_1-result',
  templateUrl: './section-84_1-result.component.html',
  styleUrls: ['./section-84_1-result.component.scss'],
  standalone: false,
})
export class Section84_1ResultComponent implements OnInit, OnDestroy {
  public calculationId: string;

  public calculationResponse: CalculationResponse;
  public options: Section84_1Options;
  public results: Section84_1Result;
  isSectionApplicationCollapsed: boolean = false;
  isSectionDeemedDividendCollapsed: boolean = false;
  isSectionAdjustedCostBaseCollapsed: boolean = false;
  isSectionCapitalGainCollapsed: boolean = false;
  isSectionShareClassesCollapsed: boolean = false;
  isSectionShareClassCollapsed: boolean = false;
  isSectionShareClassTableCollapsed: boolean = false;
  isSectionPaidUpCapitalCollapsed: boolean = false;
  isSectionReducedPaidUpCapitalCollapsed: boolean = false;
  selectedBadge: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);
  private calculationResponseSubscription: Subscription;

  constructor(private readonly calculationStore: CalculationStore,
              private readonly translateService: TranslateService,
              private readonly activatedRoute: ActivatedRoute) {

    // Start by setting the calculationId
    this.calculationId = this.activatedRoute.snapshot.params.calculationId;

  }

  ngOnInit(): void {

    this.activatedRoute.parent.params.subscribe(params => {
      if (params.calculationId === undefined) {
        return;
      }

      this.calculationId = params.calculationId;

      // Unsubscribe all the subscriptions on route change.
      this.unsubscribeAll();

      this.calculationResponseSubscription = this.calculationStore.get(params.calculationId).subscribe((calculationResponse) => {
        // todo: add a mechanism to know if the results are simply loading (when calculationResponse === undefined) or there's an error (the other two conditions)
        if (calculationResponse === undefined || calculationResponse.options === undefined || calculationResponse.results === undefined) {
          return;
        }

        this.calculationResponse = calculationResponse;
        this.options = calculationResponse.options.options as Section84_1Options;
        this.results = calculationResponse.results.results as Section84_1Result;
      });
    });
  }

  ngOnDestroy() {
    this.unsubscribeAll();
  }

  getErrorText(error: string | CalculationError) {
    if (typeof error === 'string') {
      return error;
    }

    if (error.hasOwnProperty('calculationErrorKeyname')) {
      const calculationError = calculationErrorMetadata[error.calculationErrorKeyname];

      if (calculationError === undefined) {
        return 'Erreur inconnue'; // todo: translate this.
      }

      if (calculationError.i18n.hasOwnProperty(this.translateService.currentLang) && calculationError.i18n[this.translateService.currentLang] !== '') {
        return calculationError.i18n[this.translateService.currentLang];
      }

      return calculationError.i18n.fr;
    }
  }

  private unsubscribeAll() {
    this.calculationResponseSubscription?.unsubscribe();
  }
}
